<template>
    <div class="pa-5 compact-form" v-if="activeCompany">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeCompany.name"
                        @input="updateField($event, 'name')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Legal type" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeCompany.legal_type"
                        @input="updateField($event, 'legal_type')"
                        class="text-field-item mb-1"
                        :items="legal_types"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Identification code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeCompany.identification_code"
                        @input="updateField($event, 'identification_code')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "EU vat number" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeCompany.eu_vat_number"
                        @input="updateField($event, 'eu_vat_number')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeCompany.country"
                        :items="['EE', 'LV', 'LT']"
                        @input="updateField($event, 'country')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Homepage URL" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeCompany.client_url"
                        @input="updateField($event, 'client_url')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Postback URL" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                        :value="activeCompany.postback_url"
                        @input="updateField($event, 'postback_url')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Invoice payer" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeCompany.invoice_payer_id"
                        :items="editedCompanies"
                        @input="updateField($event, 'invoice_payer_id')"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                        item-text="name"
                        item-value="id"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "AIS package" | t }}</v-col>
            <v-col cols="6">
                <v-select
                        :value="activeCompany.ais_package"
                        @input="updateField($event, 'ais_package')"
                        class="text-field-item mb-1"
                        :items="aisPackages"
                        item-text="name"
                        item-value="value"
                        hide-details
                        dense
                        outlined
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Store from "../../../store";
import {mapState} from "vuex";
import {companyMixin} from "@/mixins/company-mixin";

export default {
    name: "general-info-edit-tab",
    mixins: [companyMixin],
    data() {
        return {
            legal_types: ["company", "private"]
        };
    },
    computed: {
        ...mapState(["activeCompany", "companies"]),
        editedCompanies() {
            const _companies = this.companies.map(c => {
                return {name: c.name, id: c.id}
            });
            return [{id: 0, name: "-"}, ..._companies]
        }
    },
    methods: {
        updateField(value, field) {
            Store.commit("updateActiveCompanyProperty", {prop: field, value: value});
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
